<template>
    <div class="text-center my-4">
      <h1>{{ $t('errors.404.title') }}</h1>
      <p>{{ $t('errors.404.description') }}</p>
    </div>
  </template>
  
  <script>
  export default {
    // lógica del componente
  }
  </script>
  
  <style scoped>
  /* estilos del componente */
  </style>